/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { removeLicenseHeader } from '../../_common/export-stories-utils';

export { default as SkeletonDefault } from './skeleton-default.story';
export { default as SkeletonCircular } from './skeleton-circular.story';
export { default as SkeletonInheritWidth } from './skeleton-inherit-width.story';
export { default as SkeletonInheritHeight } from './skeleton-inherit-height.story';
export { default as SkeletonFullExample } from './skeleton-full-example.story';

import SkeletonCircularSrcRaw from './skeleton-circular.story?raw';
import SkeletonDefaultSrcRaw from './skeleton-default.story?raw';
import SkeletonFullExampleSrcRaw from './skeleton-full-example.story?raw';
import SkeletonInheritHeightSrcRaw from './skeleton-inherit-height.story?raw';
import SkeletonInheritWidthSrcRaw from './skeleton-inherit-width.story?raw';

export const SkeletonDefaultSrc = removeLicenseHeader(SkeletonDefaultSrcRaw);
export const SkeletonCircularSrc = removeLicenseHeader(SkeletonCircularSrcRaw);
export const SkeletonInheritWidthSrc = removeLicenseHeader(
  SkeletonInheritWidthSrcRaw,
);
export const SkeletonInheritHeightSrc = removeLicenseHeader(
  SkeletonInheritHeightSrcRaw,
);
export const SkeletonFullExampleSrc = removeLicenseHeader(
  SkeletonFullExampleSrcRaw,
);
